import React from "react";
import { InternalSlideshowItemProps } from "./Slideshow";
import SlideshowImage from "./SlideshowImage";
import * as styles from "./Slideshow.module.scss";

import { Icon } from "@silversea-ssc/ui-components-react";
const WidenVideoPlayer = React.lazy(
  () => import("components/Video/WidenVideoPlayer")
);

type SlideshowVideoProps = InternalSlideshowItemProps & {
  onPlayClick?: () => void;
};

const SlideshowVideo: React.FC<
  React.PropsWithChildren<SlideshowVideoProps>
> = ({ onPlayClick, ...props }) => {
  const videoId = props.video?.file?.videoId;
  if (!videoId) return null;

  return (
    <React.Fragment>
      {props.fullScreenEnabled && !props.isFullscreen && (
        <SlideshowImage {...props} className={styles.slideshowVideoItem}>
          <button onClick={onPlayClick} className={styles.videoIcon}>
            <Icon name="play" size="4x" />
          </button>
        </SlideshowImage>
      )}

      {(!props.fullScreenEnabled || props.isFullscreen) && (
        <div>
          <React.Suspense fallback={<div></div>}>
            <WidenVideoPlayer
              videoId={videoId}
              trackingTitle={props.video?.trackingTitle}
              autoPlay={false}
              className={
                props.isFullscreen
                  ? styles.fullscreenInlineVideoPlayer
                  : styles.inlineVideoPlayer
              }
              responsivePoster={props.image}
              playButtonType="icon"
            />
          </React.Suspense>
          {props.description && (
            <div className={styles.imageCaptionInside}>{props.description}</div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default SlideshowVideo;
